import React from "react";

const HaldenGames = () => (
  <>
    <iframe
      frameBorder="0"
      src="https://itch.io/embed/2398092?linkback=true&amp;border_width=0&amp;bg_color=3f1259&amp;fg_color=ffffff&amp;link_color=c399e9&amp;border_color=142d2b"
      width="550"
      height="165"
      className="fade-in fade-in--no-delay itch"
      title="Stumble and Stew">
      <a href="https://octobass.itch.io/stumble-and-stew">Stumble and Stew by octobass, adamskipadamski, Madmouseman, majicmoo</a>
    </iframe>
    <iframe
      frameBorder="0"
      src="https://itch.io/embed/3149193?link_color=d79545?linkback=true&amp;border_width=0&amp;bg_color=3a3236&amp;fg_color=ffffff&amp;link_color=d79545&amp;border_color=142d2b"
      width="550"
      height="165"
      className="fade-in fade-in--no-delay itch"
      title="Solander">
      <a href="https://octobass.itch.io/solander">Solander by octobass, adamskipadamski, Madmouseman, Odettica, majicmoo</a>
    </iframe>
    <iframe title="Cat got your tongue?" src="https://itch.io/embed/1813240?linkback=true&amp;border_width=0&amp;bg_color=1d1e1e&amp;fg_color=ffffff&amp;link_color=7453af&amp;border_color=d589a4"
      width="552"
      height="167"
      frameBorder="0"
      className="fade-in fade-in--no-delay itch">
      <a href="https://octobass.itch.io/cat-got-your-tongue">Cat got your tongue? by octobass, adamskipadamski, majicmoo, Madmouseman, Odettica</a>
    </iframe>
    <iframe
      src="https://itch.io/embed/1290857?linkback=true&amp;border_width=0&amp;bg_color=d1668c&amp;fg_color=ffffff&amp;link_color=ffffff&amp;border_color=d589a4"
      width="550"
      height="165"
      frameBorder="0"
      title="Don't Bug Me!"
      className="fade-in fade-in--no-delay itch"
    >
      <a href="https://octobass.itch.io/dont-bug-me">
        Don't Bug Me! by octobass, majicmoo, Odettica, Madmouseman,
        adamskipadamski
      </a>
    </iframe>
    <iframe
      src="https://itch.io/embed/838602?linkback=true&amp;border_width=0&amp;bg_color=2f1d37&amp;fg_color=ffffff&amp;link_color=ff0097&amp;border_color=ff0097"
      width="550"
      height="165"
      frameBorder="0"
      title="Lunar Heist"
      className="fade-in fade-in--no-delay itch"
    >
      <a href="https://octobass.itch.io/lunar-heist">
        Lunar Heist by octobass, majicmoo, adamskipadamski, Madmouseman
      </a>
    </iframe>
  </>
);

export default HaldenGames;
